export default __webpack_public_path__ + "static/media/Intro (1).e3ff3ab8.png";